import {handleActions} from 'redux-actions'
import * as ActionTypes from './actionTypes'

const createReducer = () => {
    const initialState = {
        columnsOrder: [],
        columnsSelected: {},
    }

    return handleActions({
        [ActionTypes.ORDER_SET]: (state, {payload: columnsOrder}) => ({
            ...state,
            columnsOrder: columnsOrder,
        }),
        [ActionTypes.SELECTED_SET]: (state, {payload: columnsShown}) => ({
            ...state,
            columnsSelected: columnsShown,
        }),
    }, initialState)
}

export default createReducer



// WEBPACK FOOTER //
// ./web/js/taskManagement/tasksTable/configurationMenu/reducer.js